import * as CONST from "./const";
import axios from "axios";
import { Spinner } from '@chakra-ui/react'
import wg_logo_black from "../logos/WG Black.png"
import wg_logo_white from "../logos/WG White.png"
import eg_logo_black from "../logos/eg_logo_Black.png"
import eg_logo_white from "../logos/eg_logo_white.png"
import shareIcon from '../images/share.png'
import uploadIcon from '../images/upload.png'
import albumIcon from '../images/albumSelection.png'
import posthog from 'posthog-js'
import { chrome, opera, firefox, safari, edge, android, ios, APP_BANNER_DISMISSED_KEY, PLAY_STORE_URL, STORAGE_KEY } from "../context/workConstants";
import RECORDING_FLAGS from './posthogFlags'
import { GetProfile as GetProfileFromShared } from '@egreact/shared'
import copy from "clipboard-copy";


export function downloadVideo(currentQualityUrl, setQualityVideo) {
  const tempAnchor = document.createElement('a');
  tempAnchor.href = currentQualityUrl;
  const videoFileName = currentQualityUrl.split('/').pop().split('?')[0];
  window.__LAST_DOWNLOAD_NAME__ = videoFileName;
  tempAnchor.setAttribute('download', videoFileName);
  tempAnchor.click();
  setQualityVideo(false);
}

export async function downloadQRCode(qrRef, booking_name) {
  const qrCanvas = qrRef.current?.querySelector("canvas");

  if (!qrCanvas) {
    alert("QR Code is not ready yet. Please try again.");
    return;
  }
  
  try {
    const bgImage = new Image();
    bgImage.crossOrigin = "anonymous"; 
    bgImage.src = "https://assets.eventgraphia.com/site_media/templates/GuestUploads.jpeg"; 

    await new Promise((resolve, reject) => {
      bgImage.onload = resolve;
      bgImage.onerror = () => reject(new Error("Failed to load background image"));
    });

    const combinedCanvas = document.createElement("canvas");
    const ctx = combinedCanvas.getContext("2d");

    combinedCanvas.width = bgImage.width;
    combinedCanvas.height = bgImage.height;

    ctx.drawImage(bgImage, 0, 0, combinedCanvas.width, combinedCanvas.height);

    
    const textToShow = (booking_name|| "Scan to upload photos!").toUpperCase();;

      const names = textToShow.split(" ");
      await document.fonts.load("300px 'Cormorant SC'");
      ctx.font = "normal 300px 'Cormorant SC'";
      ctx.fillStyle = "#596632";
      ctx.textAlign = "center";

      const textX = combinedCanvas.width / 2;

      const firstLineY = 725;
      const lineGap = 280;

      if (names.length > 1) {
        const firstName = `${names[0].trim()} ${names[1].trim()}`;
        const secondName = names.slice(2).join(" ").trim();
        ctx.fillText(firstName, textX, firstLineY);
        ctx.fillText(secondName, textX, firstLineY + lineGap);
      } else {
        ctx.fillText(textToShow, textX, firstLineY);
      }

    const qrSize = 1400; 
    const xPosition = (combinedCanvas.width - qrSize) / 2; 
    const yPosition = (combinedCanvas.height - qrSize) / 2 + 600; 
    ctx.drawImage(qrCanvas, xPosition, yPosition, qrSize, qrSize);

    const pngUrl = combinedCanvas.toDataURL("image/png");

    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    const fileName = booking_name+'.png';
    window.__LAST_DOWNLOAD_NAME__ = fileName;
    downloadLink.download = fileName;
    
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

  } catch (error) {
    console.error("error",error)
    alert("There was an error generating the poster. Please try again.");
  }
}

export function copyLinkUrl(link, setShowToast, setToastMessage) {
  setShowToast(true);
  setToastMessage({ title: 'Copied!' });
  copy(link);
}

export async function exportImage(viewUrl,setLoadingHD) {
  if (!isMobile()) {
    alert("Please open this page on a mobile device to share the image.");
    setLoadingHD(false);
    return;
  }

  if (!navigator.share) {
    alert("Sharing is not supported on this device.");
    setLoadingHD(false);
    return;
  }

  try {
    const response = await fetch(viewUrl);
    const blob = await response.blob();

    // Name the shared file to match its ACTUAL type — the view image is now
    // WebP (SD), so a hardcoded "photo.jpg" would mislabel it. Fall back to jpg.
    const shareExt = (blob.type && blob.type.split("/")[1]) || "jpg";
    const file = new File([blob], `photo.${shareExt}`, {
      type: blob.type || "image/jpeg",
    });
    setLoadingHD(false);
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        title: " ",
        files: [file],
      });
    } 
  } catch (error) {
     if (
    error?.name === "AbortError" ||
    error?.name === "NotAllowedError"
  ) {
    setLoadingHD(false);
    return;
  }
    alert("Failed to share image.");
    setLoadingHD(false);
  }
}

export function getBrowserType() {
  const ua = navigator.userAgent.toLowerCase();

  if (ua.includes('firefox')) return firefox;
  if (ua.includes('edg')) return edge;
  if (ua.includes('opr') || ua.includes('opera')) return opera;
  if (ua.includes('chrome')) return chrome;
  if (ua.includes('safari')) return safari;
  return 'unknown';
}

/** Returns the device OS from the user agent: android, ios, or unknown. */
export function getDeviceOS() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  if (/android/i.test(userAgent)) return android;
  if (/iphone|ipad|ipod/i.test(userAgent)) return ios;
  return 'unknown';
}

/** Laptop/desktop browser — not a physical Android phone/tablet (which use arm, not x86). */
function isDesktopBrowserEnvironment() {
  const platform = navigator.platform || "";

  if (/Win32|Win64/i.test(platform)) return true;
  // MacBooks report MacIntel; iPads use MacIntel with multi-touch
  if (/MacIntel/i.test(platform) && navigator.maxTouchPoints <= 1) return true;
  // Linux laptops use x86; DevTools Android emulation keeps x86 — real devices use arm/aarch64
  if (/Linux x86|Linux i686/i.test(platform)) return true;

  return false;
}

/** Physical Android device (platform), even when Chrome "Desktop site" spoofs a desktop UA. */
function isAndroidPhysicalDevice() {
  const platform = navigator.platform || "";
  return /Android|Linux armv|Linux aarch64/i.test(platform);
}

/** True when the physical screen size matches a typical Android tablet (not a phone). */
function hasLargeAndroidScreen() {
  const minScreenSide = Math.min(window.screen.width, window.screen.height);
  const maxScreenSide = Math.max(window.screen.width, window.screen.height);
  return minScreenSide >= 533 || maxScreenSide >= 900;
}

/** True on Android tablets, including Chrome "Desktop site" mode with a spoofed desktop UA. */
function isAndroidTabletLikeDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  const largeScreen = hasLargeAndroidScreen();

  if (/android/i.test(userAgent)) {
    if (!/mobile/i.test(userAgent)) return true;
    return largeScreen;
  }

  // Chrome "Desktop site" on tablet: desktop x86_64 UA but arm platform (e.g. Linux armv81)
  return isAndroidPhysicalDevice() && largeScreen;
}

/** True on Android phones, including Chrome "Desktop site" mode with a spoofed desktop UA. */
function isAndroidPhoneLikeDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  const minScreenSide = Math.min(window.screen.width, window.screen.height);

  if (/android/i.test(userAgent) && /mobile/i.test(userAgent)) {
    return minScreenSide < 533;
  }

  return isAndroidPhysicalDevice() && minScreenSide < 533;
}

/** True on real Android phones/tablets in the browser, not laptops with DevTools. */
export function isAndroidInstallBannerDevice() {
  if (isDesktopBrowserEnvironment()) return false;

  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  const hasAndroidUa = /android/i.test(userAgent);
  const onAndroidDevice = isAndroidPhysicalDevice();

  if (!hasAndroidUa && !onAndroidDevice) return false;

  const isTabletLike = isAndroidTabletLikeDevice();
  const isPhoneLike = isAndroidPhoneLikeDevice();

  if (navigator.userAgentData) {
    if (navigator.userAgentData.mobile) return true;
    if (isTabletLike || isPhoneLike) return true;
    return false;
  }

  if (isTabletLike || isPhoneLike) return true;
  return !window.matchMedia("(hover: hover) and (pointer: fine)").matches;
}

/** True if the user previously closed the Play Store install banner on this device. */
export function isPlayStoreBannerDismissed() {
  try {
    return localStorage.getItem(APP_BANNER_DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
}

/** Whether the "Open in EventGraphia App" banner should render (device, content, and dismiss state). */
export function shouldShowPlayStoreInstallBanner({ hasContent = true } = {}) {
  if (!hasContent || isEventgraphiaApp() || isPlayStoreBannerDismissed()) return false;
  return isAndroidInstallBannerDevice();
}

export function dismissPlayStoreInstallBanner(hideBanner) {
  try {
    localStorage.setItem(APP_BANNER_DISMISSED_KEY, "1");
  } catch {
  }
  if (typeof hideBanner === "function") hideBanner();
}

export function openPlayStoreOrInstallApp() {
  const devicePlatform = getDeviceOS();
  if (devicePlatform === ios) return;
  if (devicePlatform !== android) {
    window.open(PLAY_STORE_URL, "_blank", "noopener,noreferrer");
    return;
  }

  const visibilityHandler = () => clearTimeout(fallbackTimer);
  const fallbackTimer = setTimeout(() => {
    document.removeEventListener("visibilitychange", visibilityHandler);
    window.open(PLAY_STORE_URL, "_blank", "noopener,noreferrer");
  }, 1500);

  document.addEventListener("visibilitychange", visibilityHandler);
  const fallbackUrl = encodeURIComponent(PLAY_STORE_URL);
  const intentUrl = `intent://open#Intent;scheme=eventgraphia;package=com.eventgraphia.app;S.browser_fallback_url=${fallbackUrl};end`;
  window.location.href = intentUrl;
}

export function isEventgraphiaApp() {
  try {
    const authDict = JSON.parse(localStorage.getItem("auth_dict"));
    return Boolean(authDict?.is_mobile_app);
  } catch {
    return false;
  }
}

const buildErrorPayload = (error) => {
  const url = error.config?.url;

  return {
    errorType: error.response
      ? "BACKEND_ERROR"
      : error.request
      ? "NETWORK_ERROR"
      : "REQUEST_SETUP_ERROR",

    request: {
      url: url,
      method: error.config?.method,
      headers: error.config?.headers || null,
      params: error.config?.params || null,
      body: error.config?.data || null,
    },

    response: error.response
      ? {
          status: error.response.status,
          statusText: error.response.statusText,
          headers: error.response.headers || null,
          body:
            typeof error.response.data === "string"
              ? error.response.data.substring(0, 10000) // limit large HTML
              : error.response.data,
        }
      : null,

    client: {
      pageUrl: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    },

    message: error.message,
    stack: error.stack || null,
  };
};

export function setupApiFailureGuard({
  maxFailures = 5,
  windowMs = 30000,
  blockCooldownMs = 60000,
  onBlock,
  enabled = true,
}) {

  if (!enabled) {
    return;
  }

  if (axios.__isGuardAttached) {
    return;
  }
  axios.__isGuardAttached = true;

  // Helper to read and automatically clean up expired state from sessionStorage
  const getState = () => {
    try {
      const state = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
      const now = Date.now();
      let changed = false;

      // Garbage collection: remove URLs that are no longer blocked and have no recent failures
      for (const url in state) {
        const urlData = state[url];
        const isBlocked = urlData.blockedUntil && urlData.blockedUntil > now;
        const hasActiveFailures = urlData.failures.some(t => now - t < windowMs);

        if (!isBlocked && !hasActiveFailures) {
          delete state[url];
          changed = true;
        }
      }

      if (changed) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      return state;
    } catch (e) {
      return {};
    }
  };

  const saveState = (state) => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  };

  const getExactUrl = (config) => {
    if (!config) return "";
    try {
      return axios.getUri(config);
    } catch (e) {
      return config.url || "";
    }
  };

  // 1. REQUEST INTERCEPTOR
  axios.interceptors.request.use((config) => {
    const url = getExactUrl(config);
    const state = getState();
    
    // Check if it's currently blocked in storage
    if (state[url] && state[url].blockedUntil > Date.now()) {
      return Promise.reject({ blocked: true });
    }
    return config;
  });

  // 2. RESPONSE INTERCEPTOR
  axios.interceptors.response.use(
    (response) => {
      const url = getExactUrl(response.config);
      const state = getState();
      
      // On success, clear the failures and block status for this URL
      if (state[url]) {
        delete state[url];
        saveState(state);
      }
      return response;
    },
    (error) => {
      const url = getExactUrl(error.config);
      if (!url) return Promise.reject(error);

      const state = getState();
      if (!state[url]) {
        state[url] = { failures: [], logged: false, blockedUntil: null };
      }

      const now = Date.now();

      // Check if already blocked (Edge case: multiple parallel requests failing at once)
      if (state[url].blockedUntil && state[url].blockedUntil > now) {
        return Promise.reject({ ...error, blocked: true });
      }

      // -- LOGGING LOGIC --
      let username;
      let userid=null;
      try {
        const authdict = JSON.parse(localStorage.getItem("auth_dict"));
        username = authdict?.eventGraphiaName;
        userid = Number(authdict?.eventGraphiaId);   
      } catch (e) {
        console.warn("Could not parse auth_dict");
      }

      if (!url.includes("/api/error/log/") && !state[url].logged) {
        state[url].logged = true; // Mark as logged in storage
        saveState(state); // Save immediately

        const payload = {
          user_agent: getBrowserType(), // Assumed to be in scope
          user_log:
            typeof error.response?.data === "string"
              ? error.response.data.substring(0, 5000)
              : JSON.stringify(error.response?.data || error.message),
          username: username,
          userid: userid,
          egadmin_page_link: window.location.href,
        };

        fetch(getAPIUrl("/api/error/log/"), { // Assumed to be in scope
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }).catch((loggingError) => {
          console.error("Failed to send log:", loggingError.message);
        });
      }

      // -- FAILURE TRACKING & BLOCKING LOGIC --
      
      // Keep only failures within the time window
      state[url].failures = state[url].failures.filter((t) => now - t < windowMs);
      state[url].failures.push(now);

      let isNowBlocked = false;

      if (state[url].failures.length >= maxFailures) {
        isNowBlocked = true;
        state[url].blockedUntil = now + blockCooldownMs; // Set expiration time
        
        // Trigger onBlock callback
        onBlock?.(url);

        // Optional: clear block from storage after cooldown so it's clean,
        // though getState() garbage collection handles this naturally on next request.
        setTimeout(() => {
          const currentState = getState();
          if (currentState[url]) {
            delete currentState[url];
            saveState(currentState);
          }
        }, blockCooldownMs);
      }

      saveState(state);

      return Promise.reject({
        ...error,
        blocked: isNowBlocked,
      });
    }
  );
}

export function getQueryVariable(name) {
  var match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}
export function getLoginPage(data, state) {
  // data should be in stringified form
  // state should be in stringified form

  var url = CONST.S_URL + "/login";
  var next = {};
  var url_data = {};
  var curr_url_data = getAllUrlParams(window.location.href);
  if (data) {
    url_data["data"] = data;
  }
  if (state) {
    url_data["state"] = state;
  }
  url_data = Object.assign({}, url_data, curr_url_data);
  next["next_url"] = window.location.origin + window.location.pathname;
  next["url_data"] = url_data;
  url += "?next=" + JSON.stringify(next);
  // replace, not assign: the page we are leaving is either unauthenticated or
  // just logged out, so it must not stay in the history for back to land on
  window.location.replace(url);
}
export function GetProfile(callback) {
  return GetProfileFromShared(
    getAPIUrl,
    getAuthToken,
    getLoginPage,
    callback,
    undefined,
    isAdmin,
    sendPosthogInfo
  );
}
export function sendPosthogInfo({id, phone_no, name}){
  if(id && phone_no && name){
    posthog.identify(id, {
      email: phone_no + '@eventgraphia.com',
      name: name,
      pk: id,
    });
    posthog.onFeatureFlags(() => {
      if (posthog.isFeatureEnabled(RECORDING_FLAGS.recordUser)) {
        posthog.startSessionRecording();
      }
    });
  }
}
export function getAllUrlParams(url) {
  // get query string from url (optional) or window
  var queryString = url ? url.split("?")[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split("#")[0];

    // split our query string into its component parts
    var arr = queryString.split("&");

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split("=");

      // set parameter name and value (use 'true' if empty)
      var paramName = a[0];
      var paramValue = typeof a[1] === "undefined" ? true : a[1];

      if (!typeof paramValue === "string")
        paramValue = JSON.stringify(paramValue);
      if (paramName) obj[paramName] = paramValue;
    }
  }

  return obj;
}
export function getAPIUrl(x) {
  return CONST.S_URL + x;
}

export function getAuthToken() {
  return "Token " + localStorage.getItem("eventGraphiaToken");
}

export function getQuotAuthConfig() {
  const token = localStorage.getItem("quot-key");
  return {
    headers: token ? {} : { Authorization: getAuthToken() },
    params: token ? { 'quot-key': token } : {},
  };
}

export function processQuotationResponse(response, preview) {
  const collapsedDiscounts = response.estimation_details.preview_list.filter(
    item => item?.is_collapsed === true
  );
  return {
    data: response,
    preventDownloadable: !(preview || response.estimation_details.is_downloadable),
    collapsedItems: collapsedDiscounts.length ? collapsedDiscounts : null,
  };
}

export function hasTokenInstallment(installmentData) {
  // Token installments are named "Token" by the backend ("Token 1", "Token 2"
  // when there are more than one), same source the receipt's inst_type uses.
  return (installmentData || []).some(item => {
    const lname = String(item?.display_name?.lname || "").trim().toLowerCase();
    return lname.startsWith("token") && Number(item?.display_name?.cost) > 0;
  });
}

export function withQuotationYear(label, dateData) {
  // The API's day labels ("5th January", "5th Jan (Haldi)") carry no year.
  // Locked quotations are served from a stored snapshot, so the year comes
  // from date_data.date ("DD-MM-YYYY") here instead of from the API string.
  // TBA days do not start with a date and are left as they are.
  const year = String(dateData?.date || "").split("-")[2];
  if (!label || !year) {
    return label;
  }
  return label.replace(/^(\d+(?:st|nd|rd|th) [A-Za-z]+)/, `$1, ${year}`);
}

export async function applyCouponApi(estimationId, couponCode) {
  const { headers, params } = getQuotAuthConfig();
  const response = await axios.post(
    getAPIUrl('/api/estimation/coupon/apply/'),
    { estimation_id: estimationId, coupon_code: couponCode },
    { headers, params }
  );
  return response.data.message;
}

export async function removeCouponApi(estimationId, couponId) {
  const { headers, params } = getQuotAuthConfig();
  const response = await axios.post(
    getAPIUrl('/api/estimation/coupon/remove/'),
    { estimation_id: estimationId, coupon_id: couponId },
    { headers, params }
  );
  return response.data.message;
}

// EG Coins on the next installment due. Always the logged-in customer's
// token, never the shared quot-key: coins come out of a wallet, so a
// quotation opened from a shared link has nobody to take them from.
function installmentCoinsUrl(installmentId) {
  return getAPIUrl(`/api/payment/v2/installment/${installmentId}/coins/`);
}

export function hasCustomerLogin() {
  return Boolean(localStorage.getItem("eventGraphiaToken"));
}

export async function fetchInstallmentCoinsApi(installmentId) {
  const response = await axios.get(installmentCoinsUrl(installmentId), {
    headers: { Authorization: getAuthToken() },
  });
  return response.data;
}

// No amount: the server uses the whole balance, or just enough to cover
// what is left of the installment.
export async function applyInstallmentCoinsApi(installmentId) {
  const response = await axios.post(
    installmentCoinsUrl(installmentId),
    {},
    { headers: { Authorization: getAuthToken() } }
  );
  return response.data;
}

export async function fetchReferralProgrammeApi() {
  const response = await axios.get(
    getAPIUrl('/api/ads/referral-programme/')
  );
  return response.data;
}

// The caller's own code, or why it cannot be shared yet.
export async function fetchMyReferralCodeApi() {
  const response = await axios.get(
    getAPIUrl('/api/ads/my-referral-code/'),
    { headers: { Authorization: getAuthToken() } }
  );
  return response.data;
}

export async function applyReferralApi(estimationId, referralCode) {
  const { headers, params } = getQuotAuthConfig();
  const response = await axios.post(
    getAPIUrl('/api/estimation/referral/apply/'),
    { estimation_id: estimationId, referral_code: referralCode },
    { headers, params }
  );
  return response.data.message;
}

export async function removeReferralApi(estimationId, referralId) {
  const { headers, params } = getQuotAuthConfig();
  const response = await axios.post(
    getAPIUrl('/api/estimation/referral/remove/'),
    { estimation_id: estimationId, referral_id: referralId },
    { headers, params }
  );
  return response.data.message;
}

export function getLogoutFunctionality(e) {
  var logout = {
    method: "get",
    url: getAPIUrl("/api/auth/logout/"),
    headers: {
      Authorization: getAuthToken(),
    },
    contentType: "application/json; charset=utf-8",
  };

  axios(logout).then(function (response) {
    if (response.data.success) {
      localStorage.clear();
      getLoginPage();
    } else {
      alert(response.message);
    }
  });
}

export function isAdmin() {
  var status = process.env.REACT_APP_IS_ADMIN === "true";
  return status;
}

export function token_url(pre_url) {
  var url = new URL(pre_url);
  var token = localStorage.getItem("eventGraphiaToken")
  if (!token) {
    getLoginPage();
  }
  url.searchParams.set("token", token);
  return url.toString();
}

export function quotation_string(index) {
  var string1 = `Proposal `;
  var string2 = `v${index}`;
  var string = [string1, string2];
  return string;
}


export function getWhatsappShareUrl(e) {
  const shareLink = `https://wa.me/?text=${e}`
  return shareLink
}

export function globalLoader(size) {
    try {
    const state = JSON.parse(sessionStorage.getItem("api_guard_state")) || {};
    const now = Date.now();
    for (const url in state) {
      if (state[url].blockedUntil && state[url].blockedUntil > now) {
        return null; 
      }
    }
  } catch (e) {
    console.error(e);
  }
  const defaultSize = 'xl'
  return (<Spinner thickness='4px' speed='0.65s' emptyColor='gray.200' color='blue.500' size={size ? size : defaultSize} />)
}

export function isMobile() {
  const isMobileUA = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isIPadOS = navigator.maxTouchPoints > 1 && /Macintosh/i.test(navigator.userAgent);
  return (isMobileUA || isIPadOS) && isMobileScreen();
}

export function isMobileScreen() {
  const isMobileWidth = window.innerWidth <= 1224;
  return isMobileWidth;
}

export function isTouch() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}

export function defaultQuality() {
  const quality = 1080
  return quality
}

export class Platform {
  static get EG() {
      return 'eventgraphia';
  }

  static get WG() {
      return 'wedgraphia';
  }

  static get PLATFORM_LIST() {
      return [Platform.EG, Platform.WG];
  }

  static get currentPlatform() {
      return process.env.REACT_APP_PLATFORM;
  }

  static get isEG() {
      return Platform.currentPlatform === Platform.EG;
  }

  static get isWG() {
      return Platform.currentPlatform === Platform.WG;
  }
}

export function get_logo(black=false) {
  if(Platform.isEG){
    if(black) {
      return eg_logo_black
    }
    return eg_logo_white
  } else {
    if(black){
      return wg_logo_black
    }
    return wg_logo_white
  }
}

export function get_platform_bg_color() {
  if(Platform.isEG){
    return "#9f7866"
  } else {
    return "#544d44"
  }
}

export function get_platform_action_color() {
  if(Platform.isEG){
    return "#0d7575"
  } else {
    return "#0d7575"
  }
}

export const downloadReceipt = (installment_id, filename, setDownloadingReceipt) => {
  if (typeof setDownloadingReceipt === 'function') setDownloadingReceipt(true)

  return axios({
      method: 'get',
      url: getAPIUrl(`/api/payment/v2/installment/${installment_id}/receipt/`),
      headers: {
          Authorization: getAuthToken(),
          'Content-Type': 'application/json; charset=utf-8'
      },
      responseType: 'blob' 
  })
  .then(response => {
      if (response.headers['x-filename']) {
        filename = response.headers['x-filename'];
      } else if (!filename) {
        filename = 'receipt.pdf';
      }
      const blob = new Blob([response.data], { type: 'application/pdf' });
      return { blob, filename };
  })
  .then(({ blob, filename }) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      window.__LAST_DOWNLOAD_NAME__ = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
  })
  .catch(error => {
      console.error('Error downloading the PDF:', error)
      throw error
  })
  .finally(() => {
      if (typeof setDownloadingReceipt === 'function') setDownloadingReceipt(false)
  })
}

export function getCurrDateTime() {
  const currentDate = new Date();
  const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Kolkata'
  };
  return currentDate.toLocaleDateString('en-IN', options);
}

export function termsConditions(isPDF) {
  const company = Platform.isEG ? 'EventGraphia' : 'WedGraphia';
  const termsHTML = [
    {
        heading: "Final Product :",
        text: ` The client acknowledges that they are engaging ${company} for its specialized technical and artistic expertise in photography and videography.`+
              ` As such, ${company} reserves the exclusive right to edit and curate the captured images and videos in a manner that aligns with its professional`+
              ` judgment and creative vision. While ${company} will make every effort to document the event comprehensively, it is understood that not every guest`+
              ` or moment may be captured or included in the final edited images or videos. ${company} does not guarantee that every individual attending the event`+
              ` will be photographed or featured in the final deliverables, as the selection of content is subject to artistic discretion and the practical limitations`+
              ` of the event coverage.`
    },
    {
      heading: "Copyright :",
      text:(
        <>
        EventGraphia retains the perpetual rights, as granted under the Indian Copyright Act, to use the photographs and videos produced during the event for promotional, marketing, and advertising purposes. This includes, but is not limited to, showcasing the work on EventGraphia’s official website, social media platforms, portfolios, and other digital or print media channels. The Client acknowledges that these materials may be used without further notification or compensation and grants EventGraphia the necessary permissions to utilize the content in this manner.
        EventGraphia will ensure that any sensitive or private moments are handled with discretion and respect during the selection and use of images or videos for publicity.
        Additionally, EventGraphia retains exclusive rights to its brand identity, including its name, logo, watermark, and any associated branding elements. The Client shall not remove, alter, obscure, or misuse EventGraphia’s logo or branding from any photographs, videos, or deliverables, nor use EventGraphia’s brand assets independently for commercial or promotional purposes without prior written consent.
        </>
      )
    },
    {
      heading: "Raw Data Delivery Clause :",
      text:(
        <>
        EventGraphia continues to keep the events' Raw Data till 6 months after the last event date. Raw data shall be shared with the Client upon full settlement of 100% of the booking amount, along with any applicable incidentals or additional charges, if any. The Client shall procure and provide a compatible external hard drive of adequate storage capacity, as per the data size communicated by EventGraphia.
        Upon receipt of the external hard drive, EventGraphia shall require approximately seven (7) to ten (10) working days to transfer the raw data. Upon completion of the data transfer, the hard drive shall be dispatched to the Client’s specified address within India via a reputed courier service.
        EventGraphia shall share the courier receipt and tracking details upon dispatch. Once the hard drive has been handed over to the courier service, EventGraphia shall not be liable for any loss, damage, delay, or deterioration of the hard drive or its contents during transit or upon delivery, and the Client shall assume all associated risks thereafter.
        </>
      )
    },
    {
        heading: "Content Revisions and Finalization Policy :",
        text: (
          <>
            Each video delivered by {company} includes one round of revisions. Requests for changes must be submitted within 15 days of the delivery date. All requested changes should
            be consolidated and provided at once (within 15 days of delivery) to facilitate a smooth revision process. Any additional rounds of edits beyond the initial revision will incur
            extra charges. If the client does not submit their revision requests within the 15-day period, the project will be considered finalized, and no further modifications will be made.
          </>
        )
    },
    {
        heading: "Guest Upload Validity :",
        text: (
          <>
            Guest Upload feature allows only the photos to be uploaded and the videos are not allowed to be uploaded using this feature.
            <br />
            Guest photo upload is open till the 10th day of the Wedding post after which this feature is auto disabled and no more upload can be done.
          </>
        )
    },
    {
        heading: "Event Coverage and Guest Comfort :",
        text: (
          <>
            To ensure that {company}'s team can capture the event effectively, we kindly request that guests avoid standing in front of or behind the camera. This helps us to maintain the best possible
            quality of photography and videography.
            <br />
            <br />
            Additionally, please note that crowd management is outside the scope of {company}'s responsibilities. We appreciate your understanding and cooperation
            in creating a smooth and enjoyable experience for everyone involved.
            <br />
            <br />
            To ensure the comfort and privacy of your guests, {company} will not cover food and dining areas. We want to respect your
            guests' space and avoid any potential discomfort from being photographed or recorded while they are dining.
            <br />
          </>
        )
    },
    {
        heading: "Point of Contact :",
        text: (
          <>
            The client will designate one point of contact from both the bride's and groom's sides to assist and guide {company}'s team during the event. These designated individuals
            will be responsible for identifying and introducing close family members and important friends to ensure that they are appropriately photographed and included in key moments.
            Their cooperation is essential for facilitating smooth communication and capturing the most meaningful aspects of the event.
          </>
        )
    },
    {
        heading: "Artificial Lighting :",
        text: (
          <>
            {company} does not guarantee the quality of images if the artificial lighting provided by the client at the venue is unsuitable or too dim for photography or filming.
            {company} strongly recommends avoiding the use of colored LED lights, flickering lights, or lasers in the ambient, seating, or performance areas during the wedding.
          </>
        )
    },
    {
        heading: "Power and Setup Requirements :",
        text: (
          <>
            For the successful setup and operation of our equipment, we require access to a power supply of 5 amps/220-230 volts at each event location. Additionally, a table measuring 4’x2’ is needed to securely
            place and organize our equipment.
          </>
        )
    },
    {
        heading: "Permissions(if any) :",
        text: (
          <>
            Drone: The client is responsible for obtaining all necessary written permissions for the use of drones at the specified event location, including clearances from the
            local police administration and the venue management. These permissions must be secured prior to the event and provided to {company}. In the event of any dispute or
            issue arising from the use of drones at the venue, {company} shall not be held responsible or liable for any damages, penalties, or refunds. The client assumes full
            responsibility for any legal or regulatory compliance related to drone operations during the event.
            <br />
            <br />
            Religious institutions: The client is solely responsible for obtaining all necessary permissions from the respective religious institutions or venues, such as temples, churches, synagogues, or other locations where the wedding ceremony or event
            will take place. This includes securing authorization for {company} to photograph and/or videograph the ceremony or event. {company} will not be liable for any issues
            arising from the lack of such permissions.
          </>
        ),
    },
    {
        heading: "Food For Crew :",
        text: (
          <>
            The client must ensure that food and beverages for our crew be arranged in the guest areas and be provided at a level consistent with that of the guests.
          </>
        )
    },
    {
      heading: "Accommodation :",
      text: (
        <>
          Accommodation for the team <i>(If mentioned in the quotation section)</i> should be provided at the same property, or at an equivalent venue as the guests, ensuring similar standards of comfort and hygiene.
          Rooms should be arranged on a triple occupancy basis at maximum.
          Accommodation should be provided for the entire duration of the event, including until the final wrap-up time.
          In case the accommodation is arranged at a different property, venue transfers (pick-up and drop) should be provided for the team as required.
        </>
      )
    },
    {
        heading: "Substitution :",
        text: (
          <>
            In the event that {company}'s designated photographer is unable to attend the event due to illness or other unforeseen circumstances beyond their control, {company} reserves the right to
            substitute another representative to take the photographs.
            <br />
            <br />
            In such cases, {company} guarantees that the substitute photographer will be a qualified and experienced professional, ensuring the
            continued delivery of high-quality photography services. We will make every effort to ensure that the substitute maintains the same level of competence and professionalism as the original photographer.
          </>
        )
    },
    {
        heading: "Rescheduling by Client :",
        text: (
          <>
            In the event of any changes to the plans or postponement of the event, {company} will make every effort to accommodate the new dates with the best available team.
            However, any rescheduling requests must be communicated to {company} at least 45 days prior to the original event date.
            <br />
            <br />
            If the wedding date is changed, an additional charge of 20% of the total value of the final package will apply. This charge covers the administrative and logistical adjustments required to accommodate the new schedule.
          </>
        )
    },
    {
      heading: "Force Majeure Clause :",
      text:(
        <>
          For the purpose of this agreement, a force majeure event shall include, but not be limited to, acts of God, natural disasters, government restrictions, pandemics, epidemics, war, riots, civil unrest, fire, flood, or any other unforeseeable circumstances beyond the reasonable control of either party that render the event impossible to proceed as scheduled.
          In such an event, EventGraphia agrees to accommodate a one-time rescheduling of the wedding at no additional cost, for a period of up to one (1) year from the originally agreed booking dates, subject to availability.
          Personal reasons, change of venue, change of dates for convenience, or budget-related considerations shall not be considered force majeure.
        </>
      )
    },
    {
        heading: "Liability :",
        text: (
          <>
            {company}, including its agents and third-party associates, will not be held liable for any issues that may arise due to accidents, loss of materials, acts of God, equipment failure,
            or other unforeseen circumstances. This includes, but is not limited to, interference from surrounding devices, access limitations, flash restrictions, or other location-specific constraints
            that may impact the photography.
            <br />
            <br />
            {company} is also not responsible for any loss or interference with the photography resulting from these restrictions. This limitation of liability extends
            to any damage or loss of photographic materials during processing (both film and digital), camera malfunction, postal issues, fire, or other incidents beyond {company}’s control.
            <br />
            <br />
            The client acknowledges and accepts the inherent risks of event photography, which often involves capturing spontaneous and unpredictable moments. By signing this agreement, the client waives any right to legal
            action for missed or lost photographs, including claims for unintentional infliction of emotional distress or negligence. This waiver reflects the client’s understanding and acceptance of the risks
            associated with the nature of event photography work.
          </>
        )
    },
    {
        heading: "Dispute & Resolution :",
        text: (
          <>
            Any breach of this Agreement shall be governed by the provisions of this clause. This Agreement shall be governed by and construed in accordance with the laws of India.
          </>
        )
    },
    {
        heading: "Negotiation :",
        text: (
          <>
            In the event of a dispute, the aggrieved Party shall promptly notify the other Party in writing, specifying the nature of the dispute and any relevant details. The Parties shall then have 30 (thirty) days from the date
            of such notification to engage in negotiations aimed at resolving the dispute. The Parties agree to use their best efforts to resolve any disputes, disagreements, or claims arising out of or in connection
            with this Agreement through amicable negotiations. Both Parties shall engage in good faith discussions and collaborate to reach a mutually acceptable resolution in a timely manner. If the dispute remains
            unresolved at the end of this 30-day period, it shall be escalated to arbitration.
          </>
        )
    },
    {
        heading: "Arbitration :",
        text: (
          <>
            The unresolved dispute after the Negotiation shall be referred to and resolved through arbitration in accordance with the Indian Arbitration and Conciliation Act, 1996, as amended from time to time. The arbitration shall be conducted by a sole arbitrator, who will be appointed by mutual agreement of the
            Parties. If the Parties are unable to agree on the appointment of the arbitrator, the appointment shall be made in accordance with the provisions of the Indian Arbitration and Conciliation Act, 1996. The
            venue for the arbitration proceedings shall be Gurugram, Haryana, India and all arbitration proceedings shall be conducted in the English language. The Parties agree that the arbitration proceedings shall
            be conducted in a manner that is efficient and expeditious. The arbitration award shall be final, binding, and conclusive upon both Parties. The Parties agree to accept and comply with the arbitration award
            without delay. The costs of arbitration, including the arbitrator's fees, shall be borne equally by both Parties unless otherwise directed by the arbitrator.
          </>
        )
    },
  ];
  const termsPDF = [
    {
        heading: "Final Product :",
        text: ` The client acknowledges that they are engaging ${company} for its specialized technical and artistic expertise in photography and videography.`+
              ` As such, ${company} reserves the exclusive right to edit and curate the captured images and videos in a manner that aligns with its professional`+
              ` judgment and creative vision. While ${company} will make every effort to document the event comprehensively, it is understood that not every guest`+
              ` or moment may be captured or included in the final edited images or videos. ${company} does not guarantee that every individual attending the event`+
              ` will be photographed or featured in the final deliverables, as the selection of content is subject to artistic discretion and the practical limitations`+
              ` of the event coverage.`
    },
    {
      heading: "Copyright :",
      text:` EventGraphia retains the perpetual rights, as granted under the Indian Copyright Act, to use the photographs and videos produced during the event for promotional, marketing, and advertising purposes. This includes, but is not limited to, showcasing the work on EventGraphia’s official website, social media platforms, portfolios, and other digital or print media channels. The Client acknowledges that these materials may be used without further notification or compensation and grants EventGraphia the necessary permissions to utilize the content in this manner.`+
           ` EventGraphia will ensure that any sensitive or private moments are handled with discretion and respect during the selection and use of images or videos for publicity.`+
           ` Additionally, EventGraphia retains exclusive rights to its brand identity, including its name, logo, watermark, and any associated branding elements. The Client shall not remove, alter, obscure, or misuse EventGraphia’s logo or branding from any photographs, videos, or deliverables, nor use EventGraphia’s brand assets independently for commercial or promotional purposes without prior written consent.`
    },
    {
      heading: "Raw Data Delivery Clause :",
      text: ` EventGraphia continues to keep the events' Raw Data till 6 months after the last event date. Raw data shall be shared with the Client upon full settlement of 100% of the booking amount, along with any applicable incidentals or additional charges, if any. The Client shall procure and provide a compatible external hard drive of adequate storage capacity, as per the data size communicated by EventGraphia.`+
            ` Upon receipt of the external hard drive, EventGraphia shall require approximately seven (7) to ten (10) working days to transfer the raw data. Upon completion of the data transfer, the hard drive shall be dispatched to the Client’s specified address within India via a reputed courier service.`+
            ` EventGraphia shall share the courier receipt and tracking details upon dispatch. Once the hard drive has been handed over to the courier service, EventGraphia shall not be liable for any loss, damage, delay, or deterioration of the hard drive or its contents during transit or upon delivery, and the Client shall assume all associated risks thereafter.`
    },
    {
        heading: "Content Revisions and Finalization Policy :",
        text: ` Each video delivered by ${company} includes one round of revisions. Requests for changes must be submitted within 15 days of the delivery date. All requested changes should`+
              ` be consolidated and provided at once (within 15 days of delivery) to facilitate a smooth revision process. Any additional rounds of edits beyond the initial revision will incur`+
              ` extra charges. If the client does not submit their revision requests within the 15-day period, the project will be considered finalized, and no further modifications will be made.`
    },
    {
        heading: "Guest Upload Validity :",
        text: ` Guest Upload feature allows only the photos to be uploaded and the videos are not allowed to be uploaded using this feature.`+
              `\nGuest photo upload is open till the 10th day of the Wedding post after which this feature is auto disabled and no more upload can be done.`
    },
     {
        heading: "Event Coverage and Guest Comfort :",
        text: ` To ensure that ${company}'s team can capture the event effectively, we kindly request that guests avoid standing in front of or behind the camera. This helps us to maintain the best possible`+
              ` quality of photography and videography.\n\nAdditionally, please note that crowd management is outside the scope of ${company}'s responsibilities. We appreciate your understanding and cooperation`+
              ` in creating a smooth and enjoyable experience for everyone involved.\n\nTo ensure the comfort and privacy of your guests, ${company} will not cover food and dining areas. We want to respect your`+
              ` guests' space and avoid any potential discomfort from being photographed or recorded while they are dining.`
    },
    {
        heading: "Point of Contact :",
        text: ` The client will designate one point of contact from both the bride's and groom's sides to assist and guide ${company}'s team during the event. These designated individuals`+
              ` will be responsible for identifying and introducing close family members and important friends to ensure that they are appropriately photographed and included in key moments.`+
              ` Their cooperation is essential for facilitating smooth communication and capturing the most meaningful aspects of the event.`
    },
    {
        heading: "Artificial Lighting :",
        text: ` ${company} does not guarantee the quality of images if the artificial lighting provided by the client at the venue is unsuitable or too dim for photography or filming.`+
              ` \n${company} strongly recommends avoiding the use of colored LED lights, flickering lights, or lasers in the ambient, seating, or performance areas during the wedding.`
    },
        {
        heading: "Power and Setup Requirements :",
        text: ` For the successful setup and operation of our equipment, we require access to a power supply of 5 amps/220-230 volts at each event location. Additionally, a table measuring 4’x2’ is needed to securely`+
              ` place and organize our equipment.`
    },
    {
        heading: "Permissions(if any) :",
        text: ` Drone: The client is responsible for obtaining all necessary written permissions for the use of drones at the specified event location, including clearances from the`+
              ` local police administration and the venue management. These permissions must be secured prior to the event and provided to ${company}. \nIn the event of any dispute or`+
              ` issue arising from the use of drones at the venue, ${company} shall not be held responsible or liable for any damages, penalties, or refunds. \nThe client assumes full`+
              ` responsibility for any legal or regulatory compliance related to drone operations during the event.\n\nReligious institutions: The client is solely responsible for obtaining`+
              ` all necessary permissions from the respective religious institutions or venues, such as temples, churches, synagogues, or other locations where the wedding ceremony or event`+
              ` will take place. This includes securing authorization for ${company} to photograph and/or videograph the ceremony or event. ${company} will not be liable for any issues`+
              ` arising from the lack of such permissions.`
    },
    {
        heading: "Food For Crew :",
        text: ` The client must ensure that food and beverages for our crew be arranged in the guest areas and be provided at a level consistent with that of the guests.`
    },
    {
      heading: "Accommodation :",
      text: ` Accommodation for the team (If mentioned in the quotation section) should be provided at the same property, or at an equivalent venue as the guests, ensuring similar standards of comfort and hygiene. Rooms should be arranged on a triple occupancy basis at maximum. Accommodation should be provided for the entire duration of the event, including until the final wrap-up time. In case the accommodation is arranged at a different property, venue transfers (pick-up and drop) should be provided for the team as required.`
    },
    {
        heading: "Substitution :",
        text: ` In the event that ${company}'s designated photographer is unable to attend the event due to illness or other unforeseen circumstances beyond their control, ${company} reserves the right to`+
              ` substitute another representative to take the photographs.\n\nIn such cases, ${company} guarantees that the substitute photographer will be a qualified and experienced professional, ensuring the`+
              ` continued delivery of high-quality photography services. We will make every effort to ensure that the substitute maintains the same level of competence and professionalism as the original photographer.`
    },
    {
        heading: "Rescheduling by Client :",
        text: ` In the event of any changes to the plans or postponement of the event, ${company} will make every effort to accommodate the new dates with the best available team.`+
              ` However, any rescheduling requests must be communicated to ${company} at least 45 days prior to the original event date.\n\nIf the wedding date is changed, an additional`+
              ` charge of 20% of the total value of the final package will apply. This charge covers the administrative and logistical adjustments required to accommodate the new schedule.`
    },
    {
      heading: "Force Majeure Clause :",
      text:` For the purpose of this agreement, a force majeure event shall include, but not be limited to, acts of God, natural disasters, government restrictions, pandemics, epidemics, war, riots, civil unrest, fire, flood, or any other unforeseeable circumstances beyond the reasonable control of either party that render the event impossible to proceed as scheduled.`+
           ` In such an event, EventGraphia agrees to accommodate a one-time rescheduling of the wedding at no additional cost, for a period of up to one (1) year from the originally agreed booking dates, subject to availability.`+
           ` Personal reasons, change of venue, change of dates for convenience, or budget-related considerations shall not be considered force majeure.`
    },
    {
        heading: "Liability :",
        text: ` ${company}, including its agents and third-party associates, will not be held liable for any issues that may arise due to accidents, loss of materials, acts of God, equipment failure,`+
              ` or other unforeseen circumstances. This includes, but is not limited to, interference from surrounding devices, access limitations, flash restrictions, or other location-specific constraints`+
              ` that may impact the photography.\n\n${company} is also not responsible for any loss or interference with the photography resulting from these restrictions. This limitation of liability extends`+
              ` to any damage or loss of photographic materials during processing (both film and digital), camera malfunction, postal issues, fire, or other incidents beyond ${company}’s control.\n\nThe client`+
              ` acknowledges and accepts the inherent risks of event photography, which often involves capturing spontaneous and unpredictable moments. By signing this agreement, the client waives any right to legal`+
              ` action for missed or lost photographs, including claims for unintentional infliction of emotional distress or negligence. This waiver reflects the client’s understanding and acceptance of the risks`+
              ` associated with the nature of event photography work.`
    },
    {
        heading: "Dispute & Resolution :",
        text: ` Any breach of this Agreement shall be governed by the provisions of this clause. This Agreement shall be governed by and construed in accordance with the laws of India.`
    },
    {
        heading: "Negotiation :",
        text: ` In the event of a dispute, the aggrieved Party shall promptly notify the other Party in writing, specifying the nature of the dispute and any relevant details. The Parties shall then have 30 (thirty)`+
              ` days from the date of such notification to engage in negotiations aimed at resolving the dispute. The Parties agree to use their best efforts to resolve any disputes, disagreements, or claims arising`+
              ` out of or in connection with this Agreement through amicable negotiations. Both Parties shall engage in good faith discussions and collaborate to reach a mutually acceptable resolution in a timely manner.`+
              ` If the dispute remainsunresolved at the end of this 30-day period, it shall be escalated to arbitration.`
              
    },
    {
        heading: "Arbitration :",
        text: ` The unresolved dispute after the Negotiation shall be referred to and resolved through arbitration`+
              ` in accordance with the Indian Arbitration and Conciliation Act, 1996, as amended from time to time. The arbitration shall be conducted by a sole arbitrator, who will be appointed by mutual agreement of the`+
              ` Parties. If the Parties are unable to agree on the appointment of the arbitrator, the appointment shall be made in accordance with the provisions of the Indian Arbitration and Conciliation Act, 1996. The`+
              ` venue for the arbitration proceedings shall be Gurugram, Haryana, India and all arbitration proceedings shall be conducted in the English language. The Parties agree that the arbitration proceedings shall`+
              ` be conducted in a manner that is efficient and expeditious. The arbitration award shall be final, binding, and conclusive upon both Parties. The Parties agree to accept and comply with the arbitration award`+
              ` without delay. The costs of arbitration, including the arbitrator's fees, shall be borne equally by both Parties unless otherwise directed by the arbitrator.`
    },
    
  ];
  const data = isPDF ? termsPDF : termsHTML;
  return data;
}

export function areObjectsEqual (obj1, obj2) {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    if (!keys2.includes(key)) return false;

    if (obj1[key].length !== obj2[key].length) return false;

    const photoIds1 = obj1[key].map(item => item.photo_id);
    const photoIds2 = obj2[key].map(item => item.photo_id);

    photoIds1.sort();
    photoIds2.sort();

    for (let i = 0; i < photoIds1.length; i++) {
      if (photoIds1[i] !== photoIds2[i]) return false;
    }
  }

  return true;
};

export function getMobileOperatingSystem() {
  if (typeof window === "undefined") {
    return "unknown";
  }
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }
  if (/android/i.test(userAgent)) {
    return "Android";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }
  return "unknown";
}

export function canvasToDataURL(obj, width, height) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(obj, 0, 0, canvas.width, canvas.height);
  const imageDataURL = canvas.toDataURL('image/png');
  return imageDataURL
}

export function catchError(error) {
  if (error?.blocked) return;
  if (error.response && error.response.status === 401) {
    getLoginPage();
  } else {
    console.error("Error:", error);
  }
}

export function getApiUrlFromSelectionType(selectionType) {
  const baseUrl = process.env.REACT_APP_STAG_URL;
  switch (selectionType) {
      case 'hide':
          return `${baseUrl}/api/work/multiple/private/replace/`;
      case 'download':
          return `${baseUrl}/api/work/url/selected_imgs/`;
      case 'addTo':
          return `${baseUrl}/api/work/my/modify/`;
      case 'delete_guest_gallery':
          return `${baseUrl}/api/work/guest/gallery/delete/`;
      case 'like_photos':
          return `${baseUrl}/api/work/photo/likes/`;
      case 'view_photos':
          return `${baseUrl}/api/work/photo/views/`;
      case 'flag_photos':
          return `${baseUrl}/api/work/flag/`;
      case 'approve_photos':
          return `${baseUrl}/api/work/blacklist/approve/`;
      default:
          throw new Error(`Invalid selection type: ${selectionType}`);
  }
}

export function checkPlurality(array, string){
  if(array.length > 1){
    return `${array.length} ${string}s`
  }else{
    return `${array.length} ${string}`
  }
}

export function detectBrowser() {
  const userAgent = navigator.userAgent;

  if (userAgent.includes('Chrome') && !userAgent.includes('Edg') && !userAgent.includes('OPR')) {
    return 'Chrome';
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'Safari';
  } else if (userAgent.includes('Firefox')) {
    return 'Firefox';
  } else if (userAgent.includes('Edg')) {
    return 'Edge';
  } else {
    return 'Chrome';
  }
}

export function get_more_logo(type) {
  const albumSelection = 'album_selection'
  const guestUploads = 'guest_gallery'
  const shareUrl = 'share_url'
  if(type===guestUploads){
    return uploadIcon
  }else if(type===shareUrl){
    return shareIcon
  }else if(type===albumSelection){
    return albumIcon
  }else{
    return ''
  }
}

export function setNavigationHistory(location, icon, data) {
  const params = new URLSearchParams(location.search);
  params.delete('face-search');
  const cleanSearch = params.toString() ? `?${params.toString()}` : '';
  const storedData = [];
  let updatedHistory = [...storedData, { nav: location.pathname + cleanSearch, navtype: icon }];
  if (data?.home_url?.url) {
    updatedHistory.push({ nav: data.home_url.url, navtype: "home_url" });
  }

  localStorage.setItem("nav_history", JSON.stringify(updatedHistory));
}

// Zip download progress is stored per work key. Entries written by older builds also carry
// every image URL, which overflows the localStorage quota on large works — strip them on
// read so whatever gets written back stays small.
export function readBatchFlags(dataKey) {
  const stored = JSON.parse(localStorage.getItem(dataKey)) || [];
  return stored.map(({ batch_name, is_downloaded }) => ({ batch_name, is_downloaded }));
}

export function writeBatchFlags(dataKey, flags) {
  localStorage.setItem(dataKey, JSON.stringify(flags));
}

export function handleLibrary (navigate) {
  navigate('/work-details?tab=userfolders')
}

export function handleActivity() {
  window.location.href = `${window.location.origin}/activity`
}

export function navigateToUrl (url) {
  const pattern = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//;
  if(pattern.test(url)){
    window.location.href = url;
  }else{
    window.location.href = `${window.location.origin}${url}`;
  }
};

export function getAllChildClassNames(classString) {
  const allDescendants = document.querySelectorAll(`.${classString} *`)
  const descendantClassNames = Array.from(allDescendants)
                                    .map(el => el.classList.value)
                                    .flatMap(cls => cls.split(" "))
                                    .filter(cls => cls.trim() !== "")
  return descendantClassNames;
}

export function getToTop (top=0) {
  if(top===0){
      window.scrollTo({
          top: 0,
          behavior: 'smooth'
      });
  }else{
      window.scrollTo({
          top: top,
          behavior: 'auto'
      });
  }
};

export function formatTime(seconds) {
  if (seconds == null || isNaN(seconds)) return "00:00";
  seconds = Math.floor(seconds);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) {
    return `${h.toString().padStart(2, "0")}:${m
      .toString()
      .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  } else {
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  }
}

export function isLandScape() {
  return window.screen.orientation.type !== 'portrait-primary'
}

export function getShareTab(switchTabs, shareData) {
  if (!shareData?.data) return [];

  if (switchTabs === 'photos') {
    return shareData.data['photo-collection'] || [];
  } else if (switchTabs === 'videos') {
    return shareData.data['video'] || [];
  } else if (switchTabs === 'albums') {
    return shareData.data['album'] || [];
  } else if (switchTabs === 'userfolders') {
    return shareData.data['folders'] || [];
  }
  return [];
}

export function getUnhiddenShareTab(switchTabs, shareData, hiddenWorkMap) {
  if (!shareData?.data) return [];

  if (switchTabs === 'photos') {
    return shareData.data['photo-collection'] || [];
  } else if (switchTabs === 'videos') {
    return (shareData.data['video'] || []).filter(
      (each) => !hiddenWorkMap?.[each.work_id]
    );
  } else if (switchTabs === 'albums') {
    return (shareData.data['album'] || []).filter(
      (each) => !hiddenWorkMap?.[each.work_id]
    );
  } else if (switchTabs === 'userfolders') {
    return (shareData.data['folders'] || []).filter(
      (each) => each.is_shareable !== false
    );
  }
  return [];
}
// PostHog event-type key builder. Formerly provided via AppContext; now a plain util.
export function getPhEventType(page, event) {
  return `${page}|${event}`;
}
